import { combineEpics } from 'redux-observable';
import { contactShareStatusesEpic } from './contacts';
import { groupShareStatusesEpic } from './groups';

export const shareStatusesEpics = combineEpics(contactShareStatusesEpic, groupShareStatusesEpic);
